import angular from 'angular';

const dependencies = ['Sq.Core', 'Sq.AppConstants', 'Sq.Workbook', 'Sq.LicenseManagement', 'Sq.Workbench', 'Sq.Vendor'];

/**
 * The Sq.Worksteps module contains all functionality related to worksteps
 */
angular.module('Sq.Worksteps', dependencies);
